import Show from '../show'

function BgDashboard() {
  return (
    <Show
      title="Budget Dashboard"
      dashboardKey="bg_dashboards"
    />
  )
}

export default BgDashboard
